<template>
  <DashboardLayout :breadcrumbs="false">
    <div class="container is-fluid">
      <div class="columns scrollable">
        <div class="column is-3" v-for="list in lists" v-if="list.items.length">
          <div class="subtitle is-clearfix">
            <div class="is-pulled-left">
              {{ $t(`dashboard.${list.title}`) }} <span>{{ list.items.length }}</span>
            </div>
            <div class="is-pulled-right">
              <b-dropdown aria-role="list">
                <div slot="trigger" class="button is-small">
                  <b-icon icon="dots-horizontal" size="is-small"/>
                </div>
                <b-dropdown-item custom>
                  <div class="has-text-grey">Сортировать колонку:</div>
                </b-dropdown-item>
                <b-dropdown-item @click.native="filter(list.title, 'date', false)">
                  {{ $t('dashboard.sort.dateAsc') }}
                </b-dropdown-item>
                <b-dropdown-item @click.native="filter(list.title, 'date', true)">
                  {{ $t('dashboard.sort.dateDesc') }}
                </b-dropdown-item>
                <b-dropdown-item @click.native="filter(list.title, 'priority', false)">
                  {{ $t('dashboard.sort.priorityAsc') }}
                </b-dropdown-item>
                <b-dropdown-item @click.native="filter(list.title, 'priority', true)">
                  {{ $t('dashboard.sort.priorityDesc') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="scrollable-col">
            <div class="cols">
              <article class="message" v-for="item in list.items">
                <div class="message-body">
                  <template v-if="item.document">
                  <div class="small-gray-text mb-1 is-clearfix">
                    <span class="is-pulled-left">{{ $t(`workflow.states.${item.document.state}`) }}</span>
                    <span class="is-pulled-right" v-if="item.document">
                      {{ item.document.term_date | localedShortDate }}
                    </span>
                  </div>
                  <div class="document">
                    <b-icon icon="clipboard-arrow-down-outline" size="is-small"
                            v-if="item.document.category === 'incoming'"/>
                    <b-icon icon="clipboard-arrow-up-outline" size="is-small"
                            v-if="item.document.category === 'outgoing'"/>
                    <b-icon icon="clipboard-account-outline" size="is-small"
                            v-if="item.document.category === 'appeal'"/>
                    <span class="register-book" v-if="item.document.register_book">
                      {{ item.document.register_book__name }}
                    </span>
                    <span class="number">
                      {{ item.document.registration_number || $t('docflow.regNumberDoesNotExists') }}
                    </span>
                    <a @click="detail({
                      object_type: `${item.document.category}_document`,
                      id: item.document.id
                    })">
                        <b-icon icon="link-variant" size="is-small"/>
                    </a>
                  </div>
                  <div class="small-gray-text">{{ item.document.description }}</div>
                  </template>

                  <template v-else-if="item.assignment">
                    <div class="small-gray-text mb-1 is-clearfix">
                      <span class="is-pulled-left">{{ $t(`workflow.states.${item.assignment.state}`) }}</span>
                      <span class="is-pulled-right" v-if="item.assignment">
                        {{ item.assignment.term_date | localedShortDate }}
                      </span>
                    </div>
                    <div class="document">
                      <span class="number">{{ $t('docflow.workflow.title') }}</span>
                    </div>
                    <div class="small-gray-text">{{ item.assignment.description }}</div>
                  </template>

                  <div class="task-card" @click="detail(item)" >
                    <div class="small-gray-text is-clearfix mb-3">
                      <span class="is-pulled-left" :class="{'text-danger': isDateExpired(item.term_date)}">
                        <b-icon icon="clock-outline" size="is-small" v-if="!isDateExpired(item.term_date)"/>
                        <b-icon icon="clock-alert-outline" size="is-small" v-else/>
                        {{ item.term_date | localedShortDate }}
                      </span>
                      <div class="is-pulled-right">
                        {{ $t(`workflow.states.${item.state}`) }}
                      </div>
                    </div>
                    <h3 class="task-title">{{ item.description }}</h3>
                    <div class="small-gray-text mb-2">{{ item.title }}</div>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
        <div class="column is-3">
          <h2 class="subtitle no-bg">{{ $t('dashboard.announcements') }}</h2>
          <div class="announce" v-for="item in dashboard.announcements">
            <div class="title">{{item.name}}</div>
            <div class="text">{{item.text}}</div>
            <div class="date">{{item.created_at | localedDateWithYear}}</div>
          </div>
          <div class="announce" v-if="!dashboard.announcements.length">
            <div class="title small-gray-text">{{ $t('interface.notificationsEmpty') }}</div>
          </div>
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import {isDateExpired} from '@/utils'
  import {mapState} from 'vuex'
  import JQuery from 'jquery'

  export default {
    components: {
      DashboardLayout
    },
    data() {
      return {
        lists: []
      }
    },
    methods: {
      filter(listTitle, by, isDesc) {
        this.lists = this.lists.map(list => {
          if(list.title === listTitle) {
            switch (by) {
              case 'date':
                list.items.sort((a, b) => {
                  let c = isDesc ? a : b
                  let d = isDesc ? b : a
                  return new Date(c.term_date) - new Date(d.term_date)
                })
                break;
              case 'priority':
                list.items.sort((a, b) => {
                  let c = a.document ? parseInt(a.document.weight) : 0
                  let d = b.document ? parseInt(b.document.weight) : 0
                  return (isDesc ? c : d) - (isDesc ? d : c)
                })
                break;
            }
          }
          return list
        });

        let filterSet = {...this.dashboardFilters}
        filterSet[listTitle] = {by, isDesc}
        this.$store.commit('Filters/SET', ['dashboardFilters', filterSet])
      },
      detail(item) {
        let name, params
        switch (item.object_type) {
          case 'assignment':
            name = 'documentDetail'
            params = {documentId: item.id}
            break;
          case 'task':
            name = 'taskDetail'
            params = {documentId: item.assignment.id, taskId: item.id}
            break;
          case 'incoming_document':
            name = 'docflowIncomingDetail'
            params = {documentId: item.id}
            break;
          case 'outgoing_document':
            name = 'docflowOutgoingDetail'
            params = {documentId: item.id}
            break;
          case 'appeal_document':
            name = 'docflowAppealDetail'
            params = {documentId: item.id}
            break;
        }
        this.$router.push({name, params})
      },
      isDateExpired
    },
    mounted() {
      this.$store.dispatch('Account/getDashboardData').then(() => {
        this.lists = []
        Object.keys(this.dashboard).map(list => {
          if (list !== 'announcements') {
            this.lists.push({
              title: list,
              filter: false,
              items: this.dashboard[list]
            })
          }
        })
        this.lists.map(list => {
          this.filter(list.title, this.dashboardFilters[list.title].by, this.dashboardFilters[list.title].isDesc)
        })
      })

      JQuery('body').on('mouseenter', '.scrollable .column', function() {
        JQuery(this).addClass('mouseover')
      });
      JQuery('body').on('mouseleave', '.scrollable .column', function() {
        JQuery(this).removeClass('mouseover')
      });
    },
    computed: {
      ...mapState('Account', ['dashboard']),
      ...mapState('Filters', ['dashboardFilters']),
      breadcrumbs() {
        return [
          {name: 'dashboard'}
        ]
      },
    }
  }
</script>

<style lang="scss" scoped>
  @media screen and (min-width: 1800px) {
    .scrollable {
      .column.is-3 {
        width: 20%;
      }
    }
  }

  .scrollable {
    overflow-x: auto;
  }

  .scrollable .column {
    position: relative;
    padding-right: 0;

    &:before {
      content: '';
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      width: 4px;
      background: #fff;
      z-index: 1;
      transition: opacity .2s ease, height .1ms linear .3s;
    }

    &.mouseover:before {
      opacity: 0;
      height: 0;
    }
  }

  .scrollable-col::-webkit-scrollbar-track,
  .scrollable::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #F5F5F5;
  }

  .scrollable-col::-webkit-scrollbar,
  .scrollable::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: #F5F5F5;
  }

  .scrollable-col::-webkit-scrollbar-thumb,
  .scrollable::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #c1c1c1;
  }

  .scrollable-col {
    height: calc(100vh - 180px);
    width: 100%;
    overflow-y: scroll;
    padding-right: 10px;
    position: relative;
  }

  .small-gray-text {
    font-size: 12px;
    color: #9E9E9E;
  }

  .message-body {
    padding: 14px 18px;
    border-bottom: 1px solid #d1d1d1;

    .text-danger {
      color: #FF3860;
    }

    .document {
      & > .icon.is-small {
        font-size: 18px;
        vertical-align: middle;
        margin-right: 3px;
      }

      .register-book {
        display: inline-block;
        background: #3899DC;
        font-weight: 900;
        font-size: 10px;
        color: #fff;
        height: 14px;
        line-height: 14px;
        vertical-align: middle;
        padding: 1px 3px 0;
        border-radius: 2px;
        margin-right: 4px;
      }

      .number {
        font-weight: bold;
        font-size: 15px;
        padding: 0 0 1px;
        vertical-align: middle;
        margin-right: 2px;
      }

      a > .icon {
        font-size: 14px;
        color: #3899DC;

        &:hover {
          color: #444;
        }
      }

    }

    .task-card {
      margin-top: 8px;
      background: #fff;
      padding: 8px 14px;
      border-radius: 5px;
      border-bottom: 1px solid #D2D2D2;
      cursor: pointer;

      .icon {
        font-size: 13px;
        margin-right: -3px;
        position: relative;
        top: -2px;
        margin-left: -2px;
      }
    }
  }

  .task-title {
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 2px;
  }

  .subtitle {
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 600;
    background: #F4F4F4;
    border-radius: 6px;
    padding: 10px 16px;
    margin-right: 14px;

    &.no-bg {
      background: transparent;
      padding: 10px 0;
      margin-right: 0;
      margin-bottom: 5px;
    }

    span {
      font-size: 12px;
      color: #9e9e9e;
      vertical-align: text-top;
    }

    .dropdown-item {
      font-weight: normal;
    }

    .dropdown.is-active .button {
      background: #E1E1E1;
    }

    .button {
      height: 18px;
      width: 32px;
      border-radius: 20px;
      background: transparent;
      border: 0;
      vertical-align: middle;

      &:hover {
        background: #E1E1E1;
      }

      .icon {
        font-size: 20px;
        color: #888888;
      }
    }
  }

  .is-6 .scrollable-col .cols {
    -webkit-column-count: 2;
    column-count: 2;
    .message {
      display: inline-block;
      width: 100%;
    }
  }

  .is-9 .scrollable-col .cols {
    -webkit-column-count: 3;
    column-count: 3;
    .message {
      display: inline-block;
      width: 100%;
    }
  }

  .announce {
    .title {
      font-size: 16px;
      line-height: 23px;
      margin-bottom: 5px;
    }
    .text {
      font-size: 12px;
      color: #494949;
      margin-bottom: 5px;
    }
    .date {
      font-size: 12px;
      color: #acacac;
    }

    &:not(:last-child) {
      margin-bottom: 18px;
    }
  }

  .message {
    border-radius: 6px;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    .message-body {
      background: #F4F4F4;
      border: 0;
      border-radius: 6px;
      padding: 10px 16px;

      .type, .term {
        color: #929292;
      }
    }
  }
</style>
